// Vendor Libraries
import { CommonModule } from '@angular/common';
// Modules
import { AutocompleteInPlaceModule } from 'SearchApp/ts/features/autocomplete-in-place/autocomplete-in-place.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { SecurityAndListAutocompleteInPlaceModule } from 'SearchApp/ts/features/autocomplete-in-place/security-and-list-autocomplete-in-place/security-and-list-autocomplete-in-place.module';
import { SecurityListSelectorModalModule } from 'SecurityListsApp/ts/features/security-list-selector-modals/security-list-selector-modal.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class ReportSecuritySearchInputModule {
}
ReportSecuritySearchInputModule.ɵfac = function ReportSecuritySearchInputModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ReportSecuritySearchInputModule)(); };
ReportSecuritySearchInputModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ReportSecuritySearchInputModule });
ReportSecuritySearchInputModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AutocompleteInPlaceModule,
        CommonModule,
        DisabledModule,
        IconModule,
        SecurityAndListAutocompleteInPlaceModule,
        SecurityListSelectorModalModule,
        TooltipModule] });
